<template>
  <div>
    <vxe-grid
      ref="table"
      size="mini"
      row-id="issuesTitle"
      resizable
      auto-resize
      highlight-hover-row
      :data="data"
      :columns="columns"
      :toolbar-config="{ slots: { buttons: 'toolbar' } }"
    >
      <template #toolbar>
        <slot name="toolbar"></slot>
      </template>

      <template #opt="{ row }">
        <div>
          <el-tooltip
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="$emit('remove', row)"
            ></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableColumns from './table-columns'
export default {
  props: {
    data: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    columns() {
      return TableColumns(this)
    },
  },
}
</script>

<style lang="scss" scoped></style>
